<template lang="pug">
  app-modal(
    :titulo="`Visualizar processo - ${numeroProcesso}`",
    @closeModal="closeModal()",
    :width="modalWidth",
    :height="modalHeight",
    :responsive="isMobile",
    :bodyStyle="{height: 'auto', padding: '0'}"
  )
    template(slot="body")
      .modal
        el-tabs(type="border-card" v-model="activeTab")
          el-tab-pane(v-for="item in configModalVisualizarProcesso" :key="item.name" :label="item.label" :name="item.name" v-if="item.show")
            span(slot="label")
              i.fal(class="fa fa-exclamation-triangle cor-warning" v-if="item.name === 'TAB_MONITORAMENTO' && item.hasIcon")
              span {{ " " + item.label }}
            component(
              v-if="activeTab === item.name",
              :is="item.component",
              :showBtnSegundaVia="false",
              :numeroProcesso="numeroProcesso",
              :tipoProcesso="tipo"
              :idProcesso="idProcesso",
              :protocolo="protocolo"
            )
    template(
      v-if="configModalVisualizarProcesso[activeTab].hasFooter",
      slot="footer"
    )
      el-button.btn-baixar-pdf(
        type="default",
        @click="configModalVisualizarProcesso[activeTab].actionButtonPdf",
        size="mini",
        v-if="configModalVisualizarProcesso[activeTab].buttonConditionPdf"
      )
        i.fas(:class="configModalVisualizarProcesso[activeTab].classIconPdf")
        b.margin-left {{ configModalVisualizarProcesso[activeTab].textButtonPdf }}
      el-button.btn-baixar-pdf(
        type="default",
        @click="configModalVisualizarProcesso[activeTab].actionButtonZip",
        v-if="configModalVisualizarProcesso[activeTab].buttonConditionZip"
        size="mini",
      )
        i.fas(:class="configModalVisualizarProcesso[activeTab].classIconZip")
        b.margin-left {{ configModalVisualizarProcesso[activeTab].textButtonZip }}
      el-button.btn-baixar-pdf(
        type="default",
        @click="configModalVisualizarProcesso[activeTab].actionButtonCopia",
        size="mini",
        v-if="configModalVisualizarProcesso[activeTab].buttonConditionSolicitarCopia"
      )
        i.fas(:class="configModalVisualizarProcesso[activeTab].classIconPdf")
        b.margin-left {{ configModalVisualizarProcesso[activeTab].textButtonCopia }}
</template>

<script>
import AppModal from '@/components/AppModal'
import AppBpmnViewer from '@/components/AppBpmnViewer'
import AppVisualizarProcessoTab from './AppVisualizarProcessoTab'
import AppVisualizarProcessosVinculadosTab from './AppVisualizarProcessosVinculadosTab.vue'
import AppVisualizarComparadorTab from './AppVisualizarComparadorTab'
import AppVisualizarHistoricoTramitacaoTab from './AppVisualizarHistoricoTramitacaoTab'
import AppVisualizarMonitoramentoAreaTab from './AppVisualizarMonitoramentoAreaTab'
import AppVisualizarAnexosTab from './AppVisualizarAnexosTab.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
// import perfisAp from '../../../../utils/ap/perfis'
const { rulesButtonConditionPdf, rulesButtonConditionZip, showVisualizarFluxo, rulesConditionCompareTab, rulesButtonConditionCopia } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const AppVisualizarCadastroTab = require(`@/screens/analise/components/modal/${process.env.ESTADO === 'ma' ? 'ma' : 'pa'}/AppVisualizarCadastroTab`).default

export default {

  components: {
    AppModal,
    AppVisualizarCadastroTab,
    AppVisualizarComparadorTab,
    AppBpmnViewer
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    idProcesso: {
      type: Number,
      required: true
    },
    numeroProcesso: {
      type: String,
      required: true
    },
    tipo: {
      type: String,
      required: false
    },
    protocolo: {
      type: String,
      required: true
    },
    isCentralInteressado: {
      type: Boolean,
      required: false
    }
  },

  data () {
    return {
      activeTab: 'TAB_CADASTRO',
      xml: null,
      fluxos: [],
      user: null,
      modalWidth: 1000,
      modalHeight: 700,
      configModalVisualizarProcesso: {
        TAB_CADASTRO: {
          label: 'Cadastro',
          name: 'TAB_CADASTRO',
          hasFooter: true,
          buttonConditionPdf: rulesButtonConditionPdf.show && rulesButtonConditionPdf.tiposProcessos.includes(this.tipo),
          buttonConditionZip: rulesButtonConditionZip.show && rulesButtonConditionPdf.tiposProcessos.includes(this.tipo),
          buttonConditionSolicitarCopia: false,
          classIconPdf: 'fa-file-pdf',
          classIconZip: 'fa-file-archive',
          textButtonPdf: 'Exportar PDF',
          textButtonZip: 'Exportar ZIP',
          textButtonCopia: 'Solicitar cópia do processo',
          component: AppVisualizarCadastroTab,
          show: true,
          actionButtonPdf: async () => {
            if (process.env.ESTADO === 'pa' || process.env.ESTADO === 'ma') {
              await this.baixarPdfProcessoViewProcess(this.idProcesso)
            } else if (process.env.ESTADO === 'ap' || process.env.ESTADO === 'ba') {
              await this.baixarPdfProcessoComAnexos(this.idProcesso)
            } else {
              await this.baixarPdfProcesso(this.idProcesso)
            }
          },
          actionButtonCopia: async () => {
            this.confirmBox(this.$messages.SOLICITAR_COPIA, this.$messages.TITULO_WARNING,
              this.enviarSolicitacaoCopia,
              () => { }, 'Enviar')
          },
          actionButtonZip: async () => {
            process.env.ESTADO === 'pa' ? await this.baixarZipProcessoViewProcess(this.idProcesso) : await this.baixarZipProcesso(this.idProcesso)
          }

        },
        TAB_PROCESSO: {
          label: 'Processo',
          name: 'TAB_PROCESSO',
          hasFooter: true,
          buttonConditionPdf: rulesButtonConditionPdf.show && rulesButtonConditionPdf.tiposProcessos.includes(this.tipo),
          buttonConditionZip: rulesButtonConditionZip.show && rulesButtonConditionPdf.tiposProcessos.includes(this.tipo),
          hasIcon: false,
          classIconPdf: 'fa-file-pdf',
          classIconZip: 'fa-file-archive',
          textButtonPdf: 'Exportar PDF',
          textButtonZip: 'Exportar ZIP',
          component: AppVisualizarProcessoTab,
          show: true,
          actionButtonPdf: async () => {
            if (process.env.ESTADO === 'ap' || process.env.ESTADO === 'ba') {
              await this.baixarPdfProcessoComAnexos(this.idProcesso)
            } else {
              await this.baixarPdfProcesso(this.idProcesso)
            }
          },
          actionButtonZip: async () => {
            await this.baixarZipProcesso(this.idProcesso)
          }
        },
        TAB_HISTORICO: {
          label: 'Histórico de Tramitação',
          name: 'TAB_HISTORICO',
          hasFooter: true,
          buttonConditionPdf: true,
          buttonConditionZip: false,
          hasIcon: false,
          classIconPdf: 'fa-file-pdf',
          textButtonPdf: 'Histórico de Tramitação',
          component: AppVisualizarHistoricoTramitacaoTab,
          show: true,
          actionButtonPdf: async () => {
            await this.baixarPdfHistoricoTramitacao(this.idProcesso)
          }
        },
        TAB_ANEXOS: {
          label: 'Anexos',
          name: 'TAB_ANEXOS',
          hasFooter: false,
          buttonConditionPdf: true,
          buttonConditionZip: false,
          hasIcon: false,
          classIconPdf: 'fa-file-pdf',
          textButtonPdf: 'Anexos',
          component: AppVisualizarAnexosTab,
          show: process.env.ESTADO === 'ap',
          actionButtonPdf: async () => {
            await this.baixarPdfHistoricoTramitacao(this.idProcesso)
          }
        },
        TAB_MONITORAMENTO: {
          label: 'Monitoramento de área',
          name: 'TAB_MONITORAMENTO',
          hasFooter: false,
          buttonConditionPdf: false,
          buttonConditionZip: false,
          hasIcon: false,
          classIconPdf: 'fa-file-pdf',
          textButtonPdf: 'Monitoramento de área',
          component: AppVisualizarMonitoramentoAreaTab,
          show: false
        },
        VISUALIZAR_FLUXO: {
          label: 'Fluxograma do Processo',
          name: 'VISUALIZAR_FLUXO',
          hasFooter: true,
          hasIcon: false,
          component: AppBpmnViewer,
          show: showVisualizarFluxo
        },
        TAB_COMPARADOR: {
          label: 'Comparar Retificações',
          name: 'TAB_COMPARADOR',
          hasFooter: true,
          component: AppVisualizarComparadorTab,
          show: rulesConditionCompareTab.show && rulesConditionCompareTab.tiposProcessos.includes(this.tipo)
        },
        PROCESSOS_VINCULADOS: {
          label: 'Processos Vinculados',
          name: 'PROCESSOS_VINCULADOS',
          hasFooter: true,
          hasIcon: false,
          component: AppVisualizarProcessosVinculadosTab,
          show: this.tipo === 'REURB_COLETIVO' && process.env.ESTADO === 'ma'
        }
      }
    }
  },

  async created () {
    this.user = await this.getUsuario()
    if (rulesButtonConditionPdf.perfisDisableButtons.includes(this.user.perfilSelecionado.codigo)) {
      this.configModalVisualizarProcesso.TAB_CADASTRO.buttonConditionPdf = false
      this.configModalVisualizarProcesso.TAB_CADASTRO.buttonConditionZip = false
      this.configModalVisualizarProcesso.TAB_PROCESSO.buttonConditionPdf = false
      this.configModalVisualizarProcesso.TAB_PROCESSO.buttonConditionZip = false
    }
    if (rulesButtonConditionCopia.show === true && rulesButtonConditionCopia.perfisEnabled.includes(this.user.perfilSelecionado.codigo)) {
      this.configModalVisualizarProcesso.TAB_CADASTRO.buttonConditionSolicitarCopia = true
    }
  },

  async mounted () {
    const configuracao = await this.getConfiguracaoMonitoramento(this.numeroProcesso)
    if (this.isCentralInteressado) {
      this.configModalVisualizarProcesso.TAB_MONITORAMENTO.show = false
    } else {
      this.configModalVisualizarProcesso.TAB_MONITORAMENTO.show = configuracao.showAbaMonitoramento
      this.configModalVisualizarProcesso.TAB_MONITORAMENTO.hasIcon = configuracao.showAlerta
    }

    this.atualizarTamanhoModal()
    window.addEventListener('resize', this.atualizarTamanhoModal)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.atualizarTamanhoModal)
  },

  methods: {
    ...mapActions({
      baixarPdfHistoricoTramitacao: 'processos/baixarPdfHistorico',
      baixarPdfProcesso: 'processos/baixarPdfProcesso',
      baixarPdfProcessoComAnexos: 'processos/baixarPdfProcessoComAnexos',
      baixarPdfProcessoViewProcess: 'processos/baixarPdfProcessoViewProcess',
      baixarZipProcesso: 'processos/baixarZipProcesso',
      baixarZipProcessoViewProcess: 'processos/baixarZipProcessoViewProcess',
      getConfiguracaoMonitoramento: 'monitoramentoAmbiental/getConfiguracaoMonitoramento',
      getUsuario: 'auth/getUsuario',
      criarMensagem: 'conversa/criarMensagem'
    }),

    closeModal () {
      this.activeTab = 'TAB_CADASTRO'
      this.$emit('closeModal')
    },

    async enviarSolicitacaoCopia () {
      try {
        const mensagem = {
          assunto: 'SOLICITACAO_DE_COPIA_DO_PROCESSO',
          tipo: 'OUVIDORIA',
          idProcesso: this.idProcesso,
          mensagemList: [
            {
              conteudo: `Solicito cópia do processo ${this.numeroProcesso}. Aguardo o recebimento do boleto para pagamento da taxa de cópia do processo.`
            }
          ],
          id: this.idConversa ? this.idConversa : null
        }
        await this.criarMensagem(mensagem)
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Solicitação de cópia enviada com sucesso')
        this.$emit('solicitacaoEnviada')
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao enviar solicitação de cópia.')
      }
    },

    atualizarTamanhoModal () {
      const w = window.innerWidth
      if (w < 780) {
        this.modalWidth = 350
        this.modalHeight = Math.min(600, window.innerHeight * 0.85)
      } else if (w < 1200) {
        this.modalWidth = w * 0.9
        this.modalHeight = 650
      } else {
        this.modalWidth = 1000
        this.modalHeight = 700
      }
    }
  },

  computed: {
    isMobile () {
      return window.innerWidth < 780
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-baixar-pdf {
    float: right;
    padding: 13px 30px;
    font-size: 15px;
    margin-right: 25px;
    margin-bottom: 15px;
  }
  .margin-left {
    margin-left: 5px;
  }

  .cor-warning {
    color: #B22222; /* substitua pelo código da cor desejada */
  }

  /deep/ .el-tabs--border-card {
    box-shadow: none;
  }

  @media (max-width: 780px) {
    .btn-baixar-pdf {
      margin-right: 70px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalVisualizarCompleto.vue